import Header from "@/components/Header";
import Footer from "@/components/Footer";
import useScrollReveal from "@/hooks/useScrollReveal";

export default function Layout({ children }) {
  useScrollReveal();
  return (
    <div className="relative min-h-screen bg-[#F6F3EF] text-[#2A3229]">
      <div className="grain-overlay" aria-hidden="true" />
      <Header />
      <main className="relative z-10 pt-20">{children}</main>
      <Footer />
    </div>
  );
}
